import cowImg from "../assets/img/darkscem.png";
import useScrollAnimation from "../hooks/useScrollAnimation";

const WhyInvest = () => {
  const textRef = useScrollAnimation();
  const imgRef = useScrollAnimation();

  return (
    <div className="pt-[40px] md:pt-[80px] pb-[40px] md:pb-[100px] w-full bg-[#1a1820] relative overflow-hidden">
      {/* Subtle accent glow to match Tokenomics styling */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#E71CA5] opacity-[0.04] rounded-full blur-[150px] pointer-events-none" />
      <div className="container mx-auto px-[6%] relative">
        <div className="content-box rounded-2xl overflow-hidden">
          <div className="grid items-center grid-cols-1 xl:grid-cols-4">
            <div
              ref={textRef}
              className="animate-on-scroll from-left py-[50px] xl:py-[40px] xl:order-none order-last xl:col-span-3 px-[20px] md:px-[51px] text-center md:text-start"
            >
              <h3 className="text-[26px] md:text-[47px] text-center font-bold font-Poppins text-white mb-8 md:mb-12">
                <span className="gradient-text">
                  Why invest in Shiny Heffers?
                </span>
              </h3>
              <p className="xl:max-w-[480px] font-Poppins text-[14px] md:text-[16px] md:leading-[40px] text-white/90 text-center xl:text-left">
                $SHIT is more than a meme coin — it's the engine funding
                sustainable food systems through wealth creation. We're deploying
                modular vertical farms in cities, harnessing robotics and
                automation to maximize yield, and restoring the ability to produce
                ultra-premium, nutrient-dense food and beef locally.
              </p>
              <div className="flex flex-wrap gap-3 mt-6 justify-center xl:justify-start">
                {highlights.map(({ id, text }) => (
                  <span
                    key={id}
                    className="rounded-full px-4 py-2 text-xs font-Poppins font-bold uppercase tracking-wider text-white bg-white/15 backdrop-blur-sm border border-white/20"
                  >
                    {text}
                  </span>
                ))}
              </div>
            </div>
            <div ref={imgRef} className="animate-on-scroll from-right flex justify-center xl:justify-end">
              <img
                className="object-contain w-full max-w-[350px] xl:max-w-none animate-float drop-shadow-2xl"
                src={cowImg}
                alt="Why invest"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyInvest;

const highlights = [
  { id: 1, text: "Cross-Chain" },
  { id: 2, text: "Agri-Tech" },
  { id: 3, text: "Real Assets" },
  { id: 4, text: "Governance" },
  { id: 5, text: "Profit Sharing" },
];
